import { InjectionToken } from '@angular/core';

export const APP_READONLY_MODE = new InjectionToken<boolean>(
  'The application is read-only. All creation and editing dialogs will be skipped.',
  { providedIn: 'root', factory: (): boolean => false }
);
